import { ITrackAreaItem } from '../interfaces/ITrackAreaItem';
import { IDataTrackAreaItem, IInOutPoint } from '../redux/timeline-data.model';

class Track implements ITrackAreaItem {
	public fromAppId: string;
	public fromAppTrackId: string;
	tracks: any[];
	public elRef: HTMLElement;
	public data: IDataTrackAreaItem;

	private _id: string;
	private _widgetId: string;
	private _inOutPoints: IInOutPoint[];

	constructor(data: IDataTrackAreaItem) {
		if (data != null && data.id != null && data.widgetid != null) {
			this._id = data.id;
			this._widgetId = data.widgetid;
			this.update(data);
		}
	}

	get id(): string {
		return this._id;
	}

	get widgetId(): string {
		return this._widgetId;
	}

	get inOutPoints(): IInOutPoint[] {
		return this._inOutPoints;
	}

	public update(data: IDataTrackAreaItem): void {
		this.data = data;
		if (data != null) {
			if (data.inoutpoints != null) {
				this._inOutPoints = data.inoutpoints;
			}
			if (data.fromAppId) {
				this.fromAppId = data.fromAppId;
			}
			if (data.fromAppTrackId) {
				this.fromAppTrackId = data.fromAppTrackId;
			}
		}
	}
}

export { Track };
